import * as React from 'react';
import { Observable, Subject } from 'rxjs';
import { ExtensionGroupsMain } from './features/ExtensionGroupsMain';
import { ExtensionGroupsProvider } from './context/ExtensionGroupsContext';
import { IExtensionGroup } from '../models/extension-group.models';
import { AuthProvider } from '@app/react-common/auth/AuthContext';
import { AppProvider } from '@app/react-common/AppContext';
import { Shop } from '@pdqdev/pdq-shared/dist/entities/Shop';
import { AngularAction } from '../../checkout/react/models/AngularAction';
import { ICheckoutExtensions } from '@pdqdev/pdq-shared/dist/interfaces/ICheckoutExtensions';

interface ExtensionGroupsProps {
  extensionGroups$: Observable<IExtensionGroup[]>;
  extensions$: Observable<ICheckoutExtensions[]>;
  shop$: Observable<Shop>;
  jwtToken: string;
  angularRoutingSubject: Subject<string>;
  angularActionSubject: Subject<AngularAction>;
  initialGroupId?: number | null;
}

export const ExtensionGroups = ({
  extensionGroups$,
  extensions$,
  shop$,
  jwtToken,
  angularRoutingSubject,
  angularActionSubject,
  initialGroupId,
}: ExtensionGroupsProps) => {
  return (
    <React.Suspense fallback={<div>Loading...</div>}>
      <AuthProvider authToken={jwtToken}>
        <AppProvider
          shop$={shop$}
          angularRoutingSubject={angularRoutingSubject}
          angularActionSubject={angularActionSubject}>
          <ExtensionGroupsProvider
            extensionGroups$={extensionGroups$}
            extensions$={extensions$}
            initialGroupId={initialGroupId}>
            <ExtensionGroupsMain />
            <div id="modal-root"></div>
          </ExtensionGroupsProvider>
        </AppProvider>
      </AuthProvider>
    </React.Suspense>
  );
};
